import React from "react";

export function MediaType({contentType}) {
    return (
        <div className="mt-3 font-bold text-alert-neutral">
            Media Type: {contentType || '-'}
        </div>
    )
}